import React from "react";

const BuyerPersonaMatter = () => {
  return (
    <div className="about_area">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="single_about_thumb mb-3">
              <div className="single_about_thumb_inner">
                <img src="/assets/images/Buyer Pesona Insights.webp" alt="Organizational Chart" />
              </div>
            </div>
          
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3 text-left">
           
              <div className="section_main_title">
                <h2>Why <span> Account Intelligence & Insights</span> Matter</h2>
              
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
              <div className="section_content_text pt-4">
                <p>
                Account Intelligence & Insights empower you to refine your go-to-market approach with precision. It extends beyond rudimentary data compilation to deliver strategic insights into business priorities, financials, tech investments, buyer groups and competitive landscape at granular level. This depth of insight enables you to craft hyper-targeted strategies, build meaningful engagement, and drive impactful business outcomes.




                </p>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerPersonaMatter;
